/* eslint-disable */
import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import LinesEllipsis from 'react-lines-ellipsis';
import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';
import Icon from '../../Icon';
import TwitterData from './twitter-data';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const WrapperBox = styled(FlexBox)`
  width: 100%;
  height: auto;
  overflow: hidden;
  padding: 90px 0 146px 0;
  font-family: ${({ theme }) => theme.fontIBMLight};
`;
const Content = styled.div`
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
`;
const Title = styled.div`
  font-size: 54px;
  color: #212833;
  font-weight:200;
  padding-bottom: 25px;
`;
const Description = styled.div`
  font-size: 16px;
  color: #48515d;
  font-family: ${({ theme }) => theme.fontIBMMedium};
  > p {
    margin-bottom: 100px;
    > a {
      color: #f0b90b;
    }
  }
`;

const SliderBox = styled.div`
  height: auto;
  /* width: 1244px; */
  width: 1260px;
  margin: 0 auto;
  position: relative;
  .slick-next,
  .slick-prev {
    display: none !important;
  }
  .slick-dots {
    bottom: -36px !important;
  }
  .slick-dots li {
    width: 50px !important;
    height: 3px !important;
  }
  .slick-dots li button {
    width: 50px !important;
    height: 3px !important;
    border-radius: 3px !important;
    background: rgba(0, 0, 0, 0.1) !important;
    padding: 0 !important;
  }
  .slick-dots li.slick-active button {
    background: #848e9c !important;
  }
  .slick-dots li button:before {
    content: '' !important;
  }
`;
const Item = styled.div`
  /* padding: 0 13px; */
`;
const ItemMargin = styled.div`
  width: 390px;
  height: 217px;
  background: rgba(255, 255, 255, 1);
  border-radius: 3px;
  border: 1px solid rgba(234, 236, 239, 1);
  padding: 30px 28px;
  > div.LinesEllipsis {
    font-size: 14px;
    margin-bottom: 28px;
    line-height: 22px;
    height: 88px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
  }
  > div.users {
    height: 40px;
    > img {
      display: block;
      float: left;
      width: 40px;
      height: 40px;
      border-radius: 100%;
    }
    > p {
      margin-left: 52px;
      height: 40px;
      > div {
        font-size: 16px;
        font-family: ${({ theme }) => theme.fontIBMRegular};
      }
      > p {
        margin: 0;
        line-height: 100%;
        > .iconfont {
          font-size: 12px;
          color: #4a90e2;
          margin-right: 4px;
        }
        > a {
          color: #48515d;
          font-size: 14px;
          font-family: ${({ theme }) => theme.fontIBMRegular};
        }
      }
    }
  }
`;

// const Previous = styled.div`
//   width: 8px;
//   position: absolute;
//   left: -16px;
//   top: 50%;
//   margin-top: -10px;
//   cursor: pointer;
//   z-index: 22;
//   .iconfont {
//     color: rgba(132, 142, 156, 0.6);
//     &:hover {
//       color: rgba(132, 142, 156, 1);
//     }
//   }
// `;
// const Next = styled.div`
//   width: 8px;
//   position: absolute;
//   right: -8px;
//   top: 50%;
//   margin-top: -10px;
//   cursor: pointer;
//   z-index: 22;
//   .iconfont {
//     color: rgba(132, 142, 156, 0.6);
//     &:hover {
//       color: rgba(132, 142, 156, 1);
//     }
//   }
// `;

type Props = {
  i18n: Object,
  locale: string,
};

export default
@withI18n
class OnTwitter extends React.Component<Props> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
  };

  constructor(props: Props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  next = () => {
    this.slider.slickNext();
  };

  previous = () => {
    this.slider.slickPrev();
  };

  render() {
    const { i18n, locale } = this.props;
    const ItemData = TwitterData[locale] || [];

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
    };

    return (
      <WrapperBox direction="column">
        <Content>
          <Title>{getLabel('exchange-onTwitter-binanceOnTwitter', i18n)}</Title>
          <Description>
            <p>
              {getLabel('exchange-onTwitter-followTwitter', i18n)}
              <a
                id="on-twitter-a-binance"
                href="https://twitter.com/binance"
                target="_blank"
                rel="noopener noreferrer nofollow"
              >
                @binance
              </a>
              {getLabel('exchange-onTwitter-anytimeAnywhere', i18n)}
            </p>
          </Description>
          <SliderBox>
            {/* <Previous onClick={this.previous}>
              <Icon type="banner-left1" />
            </Previous> */}

            <Slider ref={c => (this.slider = c)} {...settings}>
              {ItemData.map((item, index) => (
                <Item key={index}>
                  <ItemMargin>
                    <LinesEllipsis
                      text={item.comment}
                      maxLine="4"
                      ellipsis="..."
                      trimRight
                      basedOn="letters"
                    />
                    <div className="users">
                      <img src={require(`./photo/${item.photo}`)} alt={item.name} />
                      <p>
                        <div>{item.name}</div>
                        <p>
                          <Icon type={item.logo} />
                          <a href={item.link} target="_blank" rel="noopener noreferrer nofollow">
                            {'@'} {item.username}
                          </a>
                        </p>
                      </p>
                    </div>
                  </ItemMargin>
                </Item>
              ))}
            </Slider>

            {/* <Next onClick={this.next}>
              <Icon type="banner-right1" />
            </Next> */}
          </SliderBox>
        </Content>
      </WrapperBox>
    );
  }
}
